module.exports = __webpack_public_path__ + "img/mainhero.a049e88f.svg";